import type { BookingsOverviewData } from '../../domain/types'
import type { BookingsOverviewAPIResponse } from '../types'
import { mapCancelledBookings } from './cancelledBookings'
import { mapPastBookings } from './pastBookings'

export function bookingsOverviewMapper(apiResponse: BookingsOverviewAPIResponse): BookingsOverviewData {
  return {
    cancelledBookings: mapCancelledBookings(apiResponse),
    pastBookings: mapPastBookings(apiResponse),
  }
}
